import { GoatGetBuyBarData200ResponseInner } from "definitions/goat-api";
import { DetailWithPricesResponseTypeV5 } from "definitions/poizon-api";
import { ProductInfoResponseDto } from "definitions/poizon-api-product";
import { openDB } from "idb";

export type ProductPriceResponse =
  | ProductInfoResponseDto
  | DetailWithPricesResponseTypeV5
  | GoatGetBuyBarData200ResponseInner[];

const DB_NAME = "product-price-cache";
const STORE_NAME = "prices";

const dbPromise = openDB(DB_NAME, 1, {
  upgrade(db) {
    db.createObjectStore(STORE_NAME);
  },
});

export async function getCachedProductPrice(
  key: string,
): Promise<ProductPriceResponse | null> {
  const db = await dbPromise;
  return (await db.get(STORE_NAME, key)) ?? null;
}

export async function setCachedProductPrice(
  key: string,
  value: ProductPriceResponse,
) {
  const db = await dbPromise;
  await db.put(STORE_NAME, value, key);
}

export async function deleteCachedProductPrice(key: string) {
  const db = await dbPromise;
  await db.delete(STORE_NAME, key);
}
